module.exports = __webpack_public_path__ + "img/other_xiaomi1.2263f559.jpg";